<template>
    <div class="border-2 w-5 h-5 rounded-full border-r-transparent border-current transition animate-spin" v-bind="$attrs"></div>
</template>